export const price = value => `£${value}`;



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/utils/format.js